import React from "react";
import { Link } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation("clientBooking");
  return (
    <div className="appointment-footer-client">
      <div className="vs-appt-footer">
        <div className="vs-appt-footer-links">
          <Link to="/terms-conditions">{t("common:common.termsConditions")}</Link>
          <span className="vs-appt-footer-divider" aria-hidden="true" />
          <Link to="/privacy-policy">{t("common:common.privacyPolicy")}</Link>
        </div>
        <p className="vs-appt-footer-copy">
          {t("footer.copyright")}
        </p>
        <p className="vs-appt-footer-note">
          <Trans i18nKey="footer.note" ns="clientBooking" />
        </p>
        <p className="vs-appt-footer-support">
          <Trans
            i18nKey="footer.support"
            ns="clientBooking"
            components={{
              a: (
                <a
                  href={process.env.REACT_APP_SUPPORT_URL}
                  target="_blank"
                  rel="noreferrer"
                />
              ),
            }}
          />
        </p>
      </div>
    </div>
  );
}
